import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from '@99designs/emu';
import { colors, typography } from '@99designs/emu/settings';
import { FormattedHTMLMessage, FormattedReactMessage } from '@99designs/frontend-components/i18n';

interface Props {
    name: string;
    url?: string;
    hasPreposition?: boolean;
    color?: Color;
    size?: Size;
}

type Color = 'grey700' | 'white';
type Size = 'subtle' | 'root';

// Future move to typography settings
const fontSizes = {
    subtle: typography.typeScale.size2,
    root: typography.typeScale.size3,
};

const fontSizeNames: { [index: string]: keyof typeof typography.typeScale } = {
    subtle: 'size2',
    root: 'size3',
};

const StyledAttribution = styled.span<{
    attributionColor: string;
    attributionSize: number;
}>(({ attributionColor, attributionSize }) => {
    return css`
        font-family: ${typography.fontFamilies.attribution};
        color: ${attributionColor};
        font-style: italic;
        font-size: ${attributionSize}px;
    `;
});

export default function Attribution({
    name,
    url,
    color = 'grey700',
    size = 'subtle',
    hasPreposition = true,
}: Props) {
    const attributionName = url ? (
        <Link
            href={url}
            target="_blank"
            color={color}
            fontFamily={'attribution'}
            size={fontSizeNames[size]}
        >
            {name}
        </Link>
    ) : (
        <span>{name}</span>
    );
    let attribution;

    if (hasPreposition) {
        if (url) {
            attribution = (
                <FormattedReactMessage
                    message={__('by <DesignerLink>{designer}</DesignerLink>')}
                    values={{ designer: name }}
                    replacements={{ DesignerLink: attributionName }}
                />
            );
        } else {
            attribution = (
                <FormattedHTMLMessage message={__('by {designer}')} values={{ designer: name }} />
            ); // TODO: translate `by {designer}` matching `by <DesignerLink>{designer}</DesignerLink>` in Smartling for the spa project
        }
    } else {
        attribution = attributionName;
    }

    return (
        <StyledAttribution attributionColor={colors[color]} attributionSize={fontSizes[size]}>
            {attribution}
        </StyledAttribution>
    );
}
